const application = (state = [], action) => {
  switch (action.type) {
    case 'application.data':
      return Object.assign([], state, [...action.Applications]);
    case 'application.reset':
      return Object.assign([], state, []);
    default:
      return state;
  }
};

export default application;
